import { WB_W, WB_H, uid } from './whiteboardShapes';

// An approved AI illustration becomes a normal image layer: behind everything ("background") or on top ("foreground").
export function illustrationLayer({ url, width, height, placement }) {
  const w0 = width || 1024, h0 = height || 1024;
  const box = placement === 'foreground' ? { w: 340, h: 340 } : { w: WB_W - 40, h: WB_H - 40 };
  const k = Math.min(box.w / w0, box.h / h0);
  const w = Math.round(w0 * k), h = Math.round(h0 * k);
  const x = placement === 'foreground' ? WB_W - w - 30 : (WB_W - w) / 2;
  const y = placement === 'foreground' ? WB_H - h - 30 : (WB_H - h) / 2;
  return { id: uid(), type: 'image', src: url, x, y, w, h, opacity: 1, name: 'AI illustration', behind: placement !== 'foreground' };
}

// Diagram + illustration stay separate objects; only their order expresses "behind" / "in front".
export const withLayer = (objects, layer) => {
  if (!layer) return objects;
  const { behind, ...o } = layer;
  return behind ? [o, ...objects] : [...objects, o];
};

export const looksLikeScene = (s) => /\b(landscape|scene|scenery|sky|sunset|sunrise|horizon|panorama|seascape|cityscape|forest)\b/i.test(s);
